import React from 'react';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';

import TableColumnDate from 'components/reusable/TableColumnDate';
import useIsUiHidden from 'hooks/dom/useIsUiHidden';

import { Button, Card, Row, Typography } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import ProfTable from '../../ProfTable';

const { Text } = Typography;

const AssociatedMembers = ({ associatedMembersData }) => {
  const { t } = useTranslation();
  const isUiHidden = useIsUiHidden();

  const associatedMembersColumns = [
    {
      title: t('professionalReport.basicData.associatedMembers.date'),
      dataIndex: 'dateFrom',
      render: TableColumnDate,
      key: 'dateForm',
      sorter: (a, b) => new Date(b.dateFrom) - new Date(a.dateFrom),
      sortDirections: ['ascend', 'descend'],
      width: isUiHidden ? 80 : 120,
    },
    {
      title: t('professionalReport.basicData.associatedMembers.name'),
      key: 'fullName',
      render: (_, record) => record.fullName || record.name || '-',
      sorter: (a, b) => {
        const nameA = a.fullName || a.name || '';
        const nameB = b.fullName || b.name || '';
        return nameA.localeCompare(nameB);
      },
      sortDirections: ['ascend', 'descend'],
    },
    {
      title: t('professionalReport.basicData.associatedMembers.position'),
      key: 'position',
      render: (_, record) => record.role || record.position || '-',
      sorter: (a, b) => {
        const positionA = a.position || a.role || '';
        const positionB = b.position || b.role || '';
        return positionA.localeCompare(positionB);
      },
      sortDirections: ['ascend', 'descend'],
      defaultSortOrder: 'ascend',
    },
    {
      title: t('professionalReport.basicData.associatedMembers.search'),
      key: 'actions',
      render: (_, record) => (
        <Button icon={<SearchOutlined />} className="manager-link-btn">
          <Link
            //TODO - need to improve BE response to make similar namings
            to={`/search/company?manager=${
              (record?.fullName && record.fullName.split(',')[0]) || (record?.name && record.name.split(',')[0])
            }&managerCreditinfoId=${record?.memberCreditinfoId || record?.creditinfoId}`}
            target="_blank"
          >
            <Text>{t('global.managedCompaniesSearch')}</Text>
          </Link>
        </Button>
      ),
    },
  ];

  return associatedMembersData.length ? (
    <>
      <ProfTable
        bordered
        dataSource={associatedMembersData}
        columns={
          isUiHidden ? associatedMembersColumns.slice(0, associatedMembersColumns.length - 1) : associatedMembersColumns
        }
        scroll={{ x: 'max-content' }}
        pagination={{ defaultPageSize: 10, showSizeChanger: true }}
        rowKey={({ fullName, dateFrom, position, name, role }) =>
          `associatedMembers-${fullName || name}-${dateFrom}-${position || role}`
        }
        showSorterTooltip={false}
      />
      <div>
        <Trans i18nKey={'professionalReport.basicData.associatedMembers.note'} components={{ bold: <strong /> }} />
      </div>
    </>
  ) : (
    <Row>
      <Card className="card-transparent space-vertical-sm">
        {t('professionalReport.basicData.associatedMembers.noInformation')}
      </Card>
      <div>
        <Trans i18nKey={'professionalReport.basicData.associatedMembers.note'} components={{ bold: <strong /> }} />
      </div>
    </Row>
  );
};

export default AssociatedMembers;
